import MyContentContainer from "./MyContentContainer";

export default  MyContentContainer;